/**
 * A short confirmation that survives the navigation that follows it: the plan
 * change (F-195) returns to where the person came from and says what happened
 * there. `FlashToastHost`, mounted once in the app, shows it.
 */
export const FLASH_TOAST_EVENT = 'memberfy:flash-toast'

export const showFlashToast = (message: string) => {
  window.dispatchEvent(new CustomEvent<string>(FLASH_TOAST_EVENT, { detail: message }))
}
